import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { groupBy } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import SortDropDown from 'components/atoms/sortDropdown';
import PlayIcon from 'assets/images/play-icon-v1.png';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
//eslint-disable-next-line
import styles from "./styles.scss";

const PastEventGrid = props => {
  const { data, activeFilters } = props;
  const { height } = useViewport();
  let flattenedData = data.reduce(
    (acc, item) =>
      acc.concat(
        item.date.map(date => Object.assign({}, item, { date: date }))
      ),
    []
  );

  const groupData = key => {
    if (key === 'date') {
      let dateSort = flattenedData.sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      return groupBy(dateSort, key);
    } else {
      return groupBy(flattenedData, key);
    }
  };

  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const [sortOption, selectSortOption] = useState(options[0]);
  const [videoUrl, setVideoUrl] = useState(null);
  const [key, setKey] = useState('date');
  const [group, createGroup] = useState(groupData('date'));

  useEffect(() => {
    createGroup(groupData(key));
  }, [data]);

  const getVideoUrl = url => {
    setVideoUrl(url);
  };

  const onSelect = (data, option) => {
    if (option.value.includes('SORT BY MOST RECENT')) {
      createGroup(groupData('date'));
      setKey('date');
    }
    if (option.value.includes('SORT BY GENRE')) {
      createGroup(groupData('genre'));
      setKey('genre');
    }
    if (option.value.includes('SORT BY ARTIST')) {
      createGroup(groupData('artistName'));
      setKey('artistName');
    }
    if (option.value.includes('SORT BY VENUE')) {
      createGroup(groupData('venue'));
      setKey('venue');
    }
    selectSortOption(option.value);
  };

  let orderedData =
    sortOption === options[0] ? Object.keys(group) : Object.keys(group).sort();

  const showOverlay = showVideoOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={videoUrl}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'past-event-video'}
        onClosePress={() => setShowVideoOverlay(false)}
        breadcrumbList={[]}
        activeFilters={activeFilters}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'past-events-grid'} style={{ height }}>
      <div className={'header'}>
        <h2>Music Foundation Events Library</h2>
      </div>
      <div className={'sort-info'}>
        <div className={'dropdown'}>
          <SortDropDown
            options={options}
            onSelect={option => onSelect(data, option)}
            value={sortOption}
            placeholder={sortOption}
            mode={'transparent'}
          />
        </div>
      </div>
      <div className={'grid-container'}>
        {orderedData.map((key, idx) => {
          const card = group[key].sort();
          const formatted_data = key.split(',').join(', ');
          return (
            <div className={'group'} key={idx}>
              <div className={'group-info'}>
                <span className={'info-type'}>{formatted_data}</span>
              </div>
              <Row className={'grid-group-content'}>
                {card.map((list, idx) => {
                  return (
                    <Col key={idx} md={4} className={'past-events-card'}>
                      <div className={'past-event-card-container'}>
                        <div className={'video-section'}>
                          {list.videoUrl ? (
                            <div style={{ height: '100%' }}>
                              <img
                                className={'video-thumb'}
                                src={list.videoThumbNail}
                                alt={''}
                              />
                              <img
                                className={'play'}
                                src={PlayIcon}
                                alt={''}
                                onClick={() => {
                                  setShowVideoOverlay(true);
                                  getVideoUrl(list.videoUrl);
                                }}
                              />
                            </div>
                          ) : (
                            <img
                              className={'video-thumb'}
                              src={list.image}
                              alt={''}
                            />
                          )}
                        </div>
                        <div className={'content'}>
                          <h3 className={'name'}>{list.name}</h3>
                          <div className={'details'}>
                            <div className={'left'}>
                              <span className={'genre'}>{list.genre}</span>
                              <span className={'location'}>{list.venue}</span>
                            </div>
                            <div className={'right'}>
                              <span className={'duration'}>
                                {list.durationCheck && list.videoDuration}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </div>
      {showOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isFiltered: EventSelector.isEventsFiltered(state, 'past'),
    activeFilters: EventSelector.getActiveEventFiltersNames(state),
    filteredEvents: EventSelector.getFilteredEvents(state, 'past'),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleEventFilter, clearEventFilters } = EventActions;
  return bindActionCreators(
    {
      toggleEventFilter,
      clearEventFilters,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PastEventGrid);

export default withRouter(connectedComponent);

const options = [
  'SORT BY MOST RECENT',
  'SORT BY GENRE',
  'SORT BY ARTIST',
  'SORT BY VENUE',
];
